import PensionProductTypeSelector from "./filters/PensionProductTypeSelector";
import UserData from "./filters/UserData";
import TableTypeToggler from "./filters/TableTypeToggler";
import RiskFilter from "./filters/RiskFilter";
import InvestmentReturnFilter from "./filters/InvestmentReturnFilter";
import { useParams } from "react-router-dom";
import { getTableType, TableType } from "../../data/TableType";
import classNames from "classnames";

import "./sidebar.scss";

type SidebarProps = {
  className?: string;
  idPrefix?: "mobile-" | "desktop-";
};
export default function Sidebar({
  className,
  idPrefix = "desktop-",
}: SidebarProps) {
  const { tableType } = useParams();

  return (
    <div className={classNames("sidebar", className)}>
      <PensionProductTypeSelector idPrefix={idPrefix} />
      <UserData tableType={getTableType(tableType ?? "")} idPrefix={idPrefix} />
      <TableTypeToggler idPrefix={idPrefix} />
      {TableType.SAVINGSPROFILES === getTableType(tableType ?? "") && (
        <>
          <RiskFilter idPrefix={idPrefix} />
          <InvestmentReturnFilter idPrefix={idPrefix} />
        </>
      )}
    </div>
  );
}
